"use client";

import { use } from "react";

import {
  type IOnboardingPermissionsContext,
  OnboardingPermissionsContext,
} from "@/subsystems/access/onboarding/components/onboarding-permissions-context";

export const useOnboardingPermissions = (): IOnboardingPermissionsContext | null => {
  const context = use(OnboardingPermissionsContext);
  if (context === undefined) {
    throw new Error("useOnboardingPermissions must be used within a OnboardingPermissionsProvider");
  }
  return context;
};
